import * as React from 'react';
export const SwordIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#FF3DAE"
      d="M16.874 2.5h-5a.625.625 0 0 0-.495.244l-5 6.5-.755-.753a1.25 1.25 0 0 0-1.768 0l-.992.993a1.25 1.25 0 0 0 0 1.768l1.563 1.562-2.188 2.188a1.25 1.25 0 0 0 0 1.768l.992.99a1.25 1.25 0 0 0 1.767 0l2.187-2.187 1.563 1.562a1.25 1.25 0 0 0 1.769 0l.991-.992a1.251 1.251 0 0 0 0-1.768l-.753-.753 6.5-5a.625.625 0 0 0 .244-.497v-5a.625.625 0 0 0-.625-.625ZM4.116 16.875l-.992-.99 2.188-2.188.99.99-2.186 2.188Zm5.516-.625L3.75 10.368l.993-.993 5.882 5.884-.992.991Zm6.617-8.433L9.863 12.73l-.854-.855 3.933-3.933a.625.625 0 1 0-.885-.883L8.124 10.99l-.853-.855 4.911-6.386h4.067v4.067Z"
    />
  </svg>
);
